import tinycolor from 'tinycolor2';

export function getRGBColor(color: string) {
  const { r, g, b, a } = tinycolor(color).toRgb();

  const r2 = Math.round((1 - a) * 255 + a * r);
  const g2 = Math.round((1 - a) * 255 + a * g);
  const b2 = Math.round((1 - a) * 255 + a * b);

  return 'rgb(' + r2 + ',' + g2 + ',' + b2 + ')';
}
